import { defineComponent as _defineComponent } from 'vue'
import {computed, useSlots} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormGroupLabel',
  props: {
  required: {
    type: Boolean,
    default: false
  },
  label: {
    type: [String, null],
    default: null
  },
},
  setup(__props) {

const props = __props;




const slots = useSlots()

const hasLabel = computed(() => {
  return !!props.label || !!slots.default;
})

return { __sfc: true,props, slots, hasLabel, computed, useSlots }
}

})